import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root{
    --radius: 16px;
    --container: 1200px;
    --gap: 16px;
    --tap: 44px;             /* min touch target height */
  }

  /* Fluid type */
  html { font-size: 100%; }
  body {
    margin:0; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
    color:#0f172a; background:#f8fafc;
    -webkit-text-size-adjust: 100%;
  }

  /* Safe-area for iOS (sticky bars) */
  body { padding-bottom: env(safe-area-inset-bottom); }

  /* Responsive container utility */
  .container { width:100%; max-width: var(--container); margin-inline:auto; padding-inline: clamp(12px, 4vw, 24px); }

  /* Base elements */
  img, video { max-width:100%; height:auto; display:block; border-radius: 12px; }
  button, input, select, textarea { font: inherit; }
  input, select, textarea {
    min-height: var(--tap);
    border:1px solid rgba(0,0,0,.08);
    border-radius: 12px;
    padding: 10px 12px;
  }
  button {
    min-height: var(--tap);
    padding: 10px 16px; border:0; border-radius: 12px; font-weight:800; cursor:pointer;
  }

  /* Utility visibility */
  .hide-md-up { display:none; }
  @media (min-width: 768px){ .hide-md-up{ display:initial; } }
  @media (max-width: 767px){ .hide-md-down{ display:none; } }

  /* Links */
  a { color:#0ea5e9; text-decoration:none; }
  a:hover { text-decoration:underline; }
`;
